import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import Button from '../../Button/Button';
import CustomSelect from '../../FormInputs/CustomSelect/CustomSelect';
import { DateSelectorV2, TextInput, TextArea } from '../../FormInputs';
import {
  statusOptions, priorityOptions, replaceUnderscoreToSpace,
} from '../../../utils/notes';
import { formatVisitAndNoteDate } from '../../../utils/dates';

const AddEditModal = ({
  note,
  actionItemButtons,
  siteName = undefined,
  errorMessage,
  setDisableSubmit,
  setIsUnsavedChanges,
}) => {
  const [formData, setFormData] = useState(note);

  useEffect(() => {
    setFormData(note);
  }, [note]);

  const errorMessageClass = 'absolute';

  const handleSubmitButton = (item) => {
    if (item.label === 'Update' || item.label === 'Create') {
      item.onClick(formData);
    } else {
      item.onClick();
    }
  };

  useEffect(() => {
    setIsUnsavedChanges(!isEqual(note, formData));
  }, [note, formData, setIsUnsavedChanges]);

  return (
    <>
      <div className="border-b-0.5px border-vamos-blue-gray" />
      <div className="px-5.5 py-8">
        <div className="flex flex-col w-full">
          <div className="flex flex-col pb-5.5 gap-1">
            <div className="text-2xl font-bold line-clamp-1">{formData?.site_name || siteName}</div>
          </div>
          <DateSelectorV2
            value={formData.timestamp}
            setValue={(value) => { setFormData((prev) => ({ ...prev, timestamp: value && formatVisitAndNoteDate(value) })); setDisableSubmit(false); }}
            label="Date"
            dateFormat="MM/dd/yyyy"
            inputStyle={{ paddingLeft: 8 }}
            isRequired
            asteriskWidth="w-2"
            spaceY="space-y-1"
            placeholder="enter date"
            errorMessage={errorMessage.date}
            errorMessageClass={errorMessageClass}
            inputHeight="h-8"
            fontSize="text-sm"
            wrapperClassName="mb-5.5"
          />
        </div>
        <div className="flex flex-col gap-5.5 w-full">
          <TextInput
            name="title"
            label="Title"
            value={formData.title}
            setValue={(value) => { setFormData((prev) => ({ ...prev, title: value })); setDisableSubmit(false); }}
            isRequired
            asteriskWidth="w-2"
            spaceY="space-y-1"
            placeholder="enter title"
            errorMessage={errorMessage.title}
            errorMessageClass={errorMessageClass}
            inputHeight="h-8"
            fontSize="text-sm"
            inputTextPadding="px-2"
          />
          <TextArea
            name="content"
            label="Content"
            value={formData.content}
            setValue={(value) => { setFormData((prev) => ({ ...prev, content: value })); setDisableSubmit(false); }}
            placeholder="enter content"
            className="p-2"
            fontSize="text-sm"
            labelFontSize="text-sm font-medium"
            spaceY="space-y-1"
          />
          <CustomSelect
            options={statusOptions}
            value={formData.status}
            setValue={(value) => { setFormData((prev) => ({ ...prev, status: value.value })); setDisableSubmit(false); }}
            label="Status"
            fontSize={14}
            isCursorShown={false}
          />
          <CustomSelect
            options={priorityOptions}
            value={replaceUnderscoreToSpace(formData.priority)}
            setValue={(value) => { setFormData((prev) => ({ ...prev, priority: value.value })); setDisableSubmit(false); }}
            label="Priority"
            fontSize={14}
            isCursorShown={false}
          />

        </div>
      </div>
      <div className="border-b-0.5px border-vamos-blue-gray" />
      <div className="flex flex-row justify-end gap-x-3 p-5.5">
        {actionItemButtons.map((item) => (
          <Button
            key={item.label}
            type={item.type && item.type}
            color={item.variant}
            label={item.label}
            isDisabled={item.isDisabled}
            size="md"
            onClick={() => handleSubmitButton(item)}
          />
        ))}
      </div>
    </>
  );
};

AddEditModal.propTypes = {
  note: PropTypes.object.isRequired,
  actionItemButtons: PropTypes.array.isRequired,
  siteName: PropTypes.string,
  errorMessage: PropTypes.object.isRequired,
  setDisableSubmit: PropTypes.func.isRequired,
  setIsUnsavedChanges: PropTypes.func.isRequired,
};

export default AddEditModal;
